
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_77_11259)"}},[_c('path',{attrs:{"d":"M9 17.235A8.23 8.23 0 0017.235 9 8.23 8.23 0 009 .765 8.23 8.23 0 00.765 9 8.23 8.23 0 009 17.235z","fill":"#fff","stroke":"#646E87","stroke-width":"1.3","stroke-miterlimit":"10"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.476 4.704a.509.509 0 00-.942 0L7.55 7.086l-2.577.206a.51.51 0 00-.292.898L6.64 9.87l-.596 2.511a.507.507 0 00.758.553L9 11.59l2.198 1.343a.505.505 0 00.758-.553L11.36 9.87l1.96-1.679a.504.504 0 00-.292-.887l-2.577-.206-.996-2.382.021-.01z","fill":"#646E87"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_77_11259"}},[_c('rect',{attrs:{"width":"18","height":"18","fill":"#fff"}})])])])
          )
        }
      }
    